import { useState, useEffect } from 'react';

/**
 * Custom hook for countdown timer
 * @param {number} initialSeconds - Initial countdown value in seconds
 * @returns {Object} Countdown state and control functions
 */
export const useCountdown = (initialSeconds) => {
  const [countdown, setCountdown] = useState(initialSeconds);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const resetCountdown = (seconds = initialSeconds) => {
    setCountdown(seconds);
  };

  const isExpired = countdown === 0;

  return {
    countdown,
    resetCountdown,
    isExpired,
  };
};
